var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showed)?_c('noda-open-banking-widget',{ref:"paymentWidget",class:{
    'disabled-payment': _vm.disabled,
  },attrs:{"id":"payment-widget"},on:{"click":_vm.getSession}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }